// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawing-toolbox {
  position: absolute;
  top: 14px;
  right: 50px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 8px;
  background: var(--surface-primary);
  border-top: none;
  border-right: none;
  border-radius: 0 0 0 4px;
  box-sizing: border-box;
  pointer-events: auto;
}

@container (max-width: 600px) {
  .drawing-toolbox {
    top: 8px;
    right: 0;
    left: auto;
    flex-wrap: wrap;
    height: auto;
    width: fit-content;
    max-width: 80%;
    padding: 4px;
    gap: 6px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
}

.drawing-toolbox-controls {
  display: flex;
  align-items: center;
  gap: 6px;
}

.drawing-toolbox-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.drawing-toolbox-btn {
  height: 32px;
  padding: 0 10px;
  border: 1px solid var(--border-input);
  border-radius: 4px;
  background: var(--surface-primary);
  color: var(--text-primary);
  cursor: pointer;
  white-space: nowrap;
  font-size: 12px;
  transition: background 0.12s;
}

.drawing-toolbox-btn:hover {
  background: var(--surface-tertiary);
}

.drawing-toolbox-btn--finish {
  background: var(--color-brand);
  color: var(--surface-primary);
  border: none;
}

.drawing-toolbox-btn--finish:hover {
  opacity: 0.85;
  background: var(--color-brand);
}

.drawing-toolbox-style {
  min-width: 90px;
}

.drawing-toolbox-style .select-dropdown-trigger,
.drawing-toolbox-thickness .select-dropdown-trigger {
  height: 32px;
  padding: 0 6px;
  font-size: 12px;
}

.drawing-control-thickness {
  width: 48px;
  padding: 0 4px;
  border: 1px solid var(--input-border);
  border-radius: 4px;
  background: var(--surface-tertiary);
  color: var(--text-primary);
  font-size: 12px;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}

.drawing-control-thickness:focus {
  border-color: var(--color-brand);
}

.drawing-toolbox-thickness {
  min-width: 48px;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/DrawingToolBox.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE;IACE,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,yCAAyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".drawing-toolbox {\n  position: absolute;\n  top: 14px;\n  right: 50px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  padding: 0 8px;\n  background: var(--surface-primary);\n  border-top: none;\n  border-right: none;\n  border-radius: 0 0 0 4px;\n  box-sizing: border-box;\n  pointer-events: auto;\n}\n\n@container (max-width: 600px) {\n  .drawing-toolbox {\n    top: 8px;\n    right: 0;\n    left: auto;\n    flex-wrap: wrap;\n    height: auto;\n    width: fit-content;\n    max-width: 80%;\n    padding: 4px;\n    gap: 6px;\n    border-radius: 4px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  }\n}\n\n.drawing-toolbox-controls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.drawing-toolbox-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.drawing-toolbox-btn {\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid var(--border-input);\n  border-radius: 4px;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n  font-size: 12px;\n  transition: background 0.12s;\n}\n\n.drawing-toolbox-btn:hover {\n  background: var(--surface-tertiary);\n}\n\n.drawing-toolbox-btn--finish {\n  background: var(--color-brand);\n  color: var(--surface-primary);\n  border: none;\n}\n\n.drawing-toolbox-btn--finish:hover {\n  opacity: 0.85;\n  background: var(--color-brand);\n}\n\n.drawing-toolbox-style {\n  min-width: 90px;\n}\n\n.drawing-toolbox-style .select-dropdown-trigger,\n.drawing-toolbox-thickness .select-dropdown-trigger {\n  height: 32px;\n  padding: 0 6px;\n  font-size: 12px;\n}\n\n.drawing-control-thickness {\n  width: 48px;\n  padding: 0 4px;\n  border: 1px solid var(--input-border);\n  border-radius: 4px;\n  background: var(--surface-tertiary);\n  color: var(--text-primary);\n  font-size: 12px;\n  text-align: center;\n  box-sizing: border-box;\n  outline: none;\n  -webkit-appearance: textfield;\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.drawing-control-thickness:focus {\n  border-color: var(--color-brand);\n}\n\n.drawing-toolbox-thickness {\n  min-width: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
